export default {"src":"/_next/static/media/member-taking-medication-alcohol.colour.1ef4bd99.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};